module.exports = __webpack_public_path__ + "media/06_ASANBUDAPEST-Atmosphere06.46ad5195.mp3";